const outboundModal = {
  employeeRowRadioBtn: 'Layout-NavBar-OutboundModal-EmployeeRowRadioBtn',
} as const;

const navBar = {
  outboundModal,
  settingsBtn: 'Layout-NavBar-SettingsBtn',
} as const;

export const layoutLocators = {
  navBar,
  draggable: 'Layout-Draggable',
};
